import React from 'react';
import { createSvgIcon } from '../IconBase';

export default createSvgIcon(<path d="M7 4h10v15H7zM3 6h2v11H3zM19 6h2v11h-2z" />, 'AmpStories');
